import {
  GetCollaboratorsCmSheetCertificationsResponse,
  UpdateCollaboratorsCmSheetCertificationsRequest,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CmSheetCertificationsService = {
  async list(
    cmSheetId: number,
  ): Promise<GetCollaboratorsCmSheetCertificationsResponse> {
    const response =
      await httpClient.get<GetCollaboratorsCmSheetCertificationsResponse>(
        `v1/cm-sheets/${cmSheetId}/certifications`,
      );
    return response;
  },
  async update(
    cmSheetId: number,
    body: UpdateCollaboratorsCmSheetCertificationsRequest,
  ): Promise<void> {
    await httpClient.patch(`v1/cm-sheets/${cmSheetId}/certifications`, body);
  },
};

export default CmSheetCertificationsService;
